var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSelectHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 25"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 11",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 8"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18",
    d: "m18.488 6.9-7.167-5.558a2.39 2.39 0 0 0-2.927 0L1.226 6.9A3.2 3.2 0 0 0 0 9.408v9.885a2.514 2.514 0 0 0 2.5 2.524h14.716a2.514 2.514 0 0 0 2.5-2.524V9.408A3.2 3.2 0 0 0 18.488 6.9m-6.632 12.952h-4v-3.857a2 2 0 1 1 4 0zm5.913-.559a.557.557 0 0 1-.553.559H13.8v-3.857a3.944 3.944 0 1 0-7.888 0v3.857H2.5a.557.557 0 0 1-.553-.559V9.408a1.214 1.214 0 0 1 .465-.953L9.577 2.9a.457.457 0 0 1 .56 0L17.3 8.455a1.212 1.212 0 0 1 .465.953z",
    transform: "translate(1.143 -.33)",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSelectHome);
export default __webpack_public_path__ + "static/media/ic-select-home.bd469576b9b5b10d0d4b2886e8405955.svg";
export { ForwardRef as ReactComponent };